import {
  CallOutCoverageQueryParams,
  ShiftQueryParams,
  Uri,
} from '@nextforce/api'

const keys = {
  all: ['shifts'],
  detail: (params: ShiftQueryParams) => [...keys.all, params],
  crew: (uri: Uri) => [...keys.all, `?${uri}`],
  callout: (params: CallOutCoverageQueryParams) => ['call_out', params],
}

export default keys
